import React from "react";

function CoinGeckoCMCLHero() {
  return (
    <>
      <div
        className="banner-style-seven-area text-light bg-cover"
        style={{
          background:
            "url(https://validthemes.net/site-template/robok/assets/img/shape/banner-21.jpg)",
        }}
      >
        <div className="banner-seven-illustration">
          <img
            className="wow fadeInLeft"
            data-wow-delay="700ms"
            src="https://validthemes.net/site-template/robok/assets/img/illustration/15.png"
            alt="Image Not Found"
          />
          <img
            className="fade-up-anim"
            src="https://validthemes.net/site-template/robok/assets/img/illustration/14.png"
            alt="Image Not Found"
          />
        </div>
        <div className="container">
          <div className="row align-center">
            <div className="col-xl-9 col-lg-8">
              <div className="banner-seven-content">
                <h2 className="split-text-right split-text-in-right">
                  Boost Your Token’s Visibility with CoinMarketCap & CoinGecko
                  Listings
                </h2>
                <div className="info">
                  <p className="wow fadeInUp" data-wow-delay="400ms">
                    Maximize token awareness and market reach through
                    top-ranking cryptocurrency data platforms.
                  </p>
                  <div
                    className="button mt-30 wow fadeInUp"
                    data-wow-delay="600ms"
                  >
                    <a href="#" className="btn btn-style-one light">
                      Join Today
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default CoinGeckoCMCLHero;
